import { render, staticRenderFns } from "./GridRow.vue?vue&type=template&id=2236053f&"
import script from "./GridRow.vue?vue&type=script&lang=js&"
export * from "./GridRow.vue?vue&type=script&lang=js&"
import style0 from "veui-theme-dls/components/grid-row.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports